import type { Role } from "@coup/shared";
import { ROLE_ART } from "../art";
import { Icon } from "./Icon";
import styles from "./Card.module.css";

// Optional art in src/card-art/<role>.{webp,png,jpg} replaces the role icon.
const artFiles = import.meta.glob<string>("../card-art/*.{webp,png,jpg}", {
  eager: true,
  import: "default",
  query: "?url",
});
const CARD_ART: Partial<Record<Role, string>> = {};
for (const [path, url] of Object.entries(artFiles)) {
  const role = path.split("/").pop()!.split(".")[0] as Role;
  CARD_ART[role] = url;
}

/** Face sizes: [width, height, art height, icon, name font]. */
const FACE = {
  mini: [44, 62, 40, 20, 10],
  sm: [72, 100, 64, 32, 14],
  md: [116, 162, 108, 50, 19],
  lg: [120, 168, 112, 54, 20],
} as const;

interface FaceProps {
  role: Role;
  size: keyof typeof FACE;
  className?: string;
}

export function CardFace({ role, size, className }: FaceProps) {
  const [w, h, artH, icon, font] = FACE[size];
  const art = ROLE_ART[role];
  const image = CARD_ART[role];
  return (
    <div
      className={`${styles.face} ${styles[size]} ${className ?? ""}`}
      style={{ width: w, height: h }}
    >
      <div className={styles.art} style={{ height: artH, background: art.color }}>
        {image ? (
          <img src={image} alt="" />
        ) : (
          <Icon
            path={art.icon}
            size={icon}
            color="#efe4cc"
            width={size === "lg" || size === "md" ? 1.5 : 1.6}
          />
        )}
      </div>
      <div
        className={styles.name}
        style={{ fontSize: art.name.length > 8 ? Math.round(font * 0.78) : font }}
      >
        {art.name}
      </div>
    </div>
  );
}

export function CardBack({ size = "sm", className }: { size?: "sm" | "deck"; className?: string }) {
  return (
    <div className={`${styles.back} ${size === "deck" ? styles.deckBack : ""} ${className ?? ""}`}>
      <div className={styles.diamond} />
    </div>
  );
}
